import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoute = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 28,
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.66732 11.9997C9.66732 12.4417 9.49172 12.8656 9.17916 13.1782C8.8666 13.4907 8.44268 13.6663 8.00065 13.6663C7.55862 13.6663 7.1347 13.4907 6.82214 13.1782C6.50958 12.8656 6.33398 12.4417 6.33398 11.9997C6.33398 11.5576 6.50958 11.1337 6.82214 10.8212C7.1347 10.5086 7.55862 10.333 8.00065 10.333C8.44268 10.333 8.8666 10.5086 9.17916 10.8212C9.49172 11.1337 9.66732 11.5576 9.66732 11.9997Z",
			stroke: "#086ED6",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.83897 17.6623C8.61379 17.879 8.31345 18 8.00097 18C7.68849 18 7.38815 17.879 7.16297 17.6623C5.10364 15.667 2.3443 13.4383 3.68964 10.2023C4.4183 8.45234 6.16497 7.33301 8.00097 7.33301C9.83697 7.33301 11.5843 8.45301 12.3123 10.2023C13.6563 13.4337 10.9036 15.6737 8.83897 17.6623Z",
			stroke: "#086ED6",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 28,
			width: 16,
			height: 28,
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.66732 39.9997C9.66732 40.4417 9.49172 40.8656 9.17916 41.1782C8.8666 41.4907 8.44268 41.6663 8.00065 41.6663C7.55862 41.6663 7.1347 41.4907 6.82214 41.1782C6.50958 40.8656 6.33398 40.4417 6.33398 39.9997C6.33398 39.5576 6.50958 39.1337 6.82214 38.8212C7.1347 38.5086 7.55862 38.333 8.00065 38.333C8.44268 38.333 8.8666 38.5086 9.17916 38.8212C9.49172 39.1337 9.66732 39.5576 9.66732 39.9997Z",
			stroke: "#FF6D41",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.001 47.333C12.001 48.0697 10.2103 48.6663 8.00097 48.6663C5.79164 48.6663 4.00097 48.0697 4.00097 47.333M8.83897 45.6623C8.61379 45.879 8.31345 46 8.00097 46C7.68849 46 7.38815 45.879 7.16297 45.6623C5.10364 43.667 2.3443 41.4383 3.68964 38.2023C4.4183 36.4523 6.16497 35.333 8.00097 35.333C9.83697 35.333 11.5843 36.453 12.3123 38.2023C13.6563 41.4337 10.9036 43.6737 8.83897 45.6623Z",
			stroke: "#FF6D41",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8,
			y1: 19.5,
			x2: 8,
			y2: 33.5,
			stroke: "url(#paint0_linear_6022_193711)",
			strokeLinecap: "round",
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_6022_193711",
			x1: 7,
			y1: 19,
			x2: 7,
			y2: 34,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#086ED6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF6D41"
			})]
		}) })
	]
});
export default SvgRoute;
